import { QuestionBase } from './question-base';

export class DescriptionQuestion extends QuestionBase<string> {
  controlType = 'description';
}
